const DOCS = [
  {
    title: "Go receiver module",
    href: "/docs/go-receiver.html",
    desc: "Embed PairBolt in other Go programs: pairbolt.com/pairbolt/pkg/receiver.",
  },
] as const;

export function DocsHub() {
  return (
    <section id="docs" className="section">
      <div className="section-inner">
        <p className="section-label">Documentation</p>
        <h2>Docs hub</h2>
        <div className="prose">
          <p>
            PairBolt is open source under Apache-2.0. Start here for embedding the
            Go receiver; product docs ship with the source repository.
          </p>
        </div>
        <ul className="docs-list">
          {DOCS.map((doc) => (
            <li key={doc.href}>
              <a href={doc.href}>
                {doc.title} →
              </a>
              <br />
              <span style={{ color: "var(--pb-color-text-muted)", fontSize: "0.9rem" }}>
                {doc.desc}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
